// extracted by mini-css-extract-plugin
module.exports = {"container":"StorageFile_container__1QnWC","name":"StorageFile_name__3jBEC"};